import ReactGA from "react-ga";

// const env = process.env.REACT_APP_ENV;

const functions = ["event", "timing", "modalview"];

const reactGA = functions.reduce((obj, f) => {
  obj[f] = args => {
    // if (env !== "production") return;
    ReactGA[f](args);
  };
  return obj;
}, {});

export default reactGA;



// WEBPACK FOOTER //
// ./src/reactGA.js